import makeStyles from 'e100-react-components/lib/styles/makeStyles';
import { ChipProps } from './ui';
interface Props extends Pick<ChipProps, 'active'> {}

export const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  root: {
    padding: `12px 6px`,
    borderWidth: ({ active }: Props) => {
      return active ? '2px' : '1.5px';
    },
    borderColor: ({ active }: Props) => {
      return active ? palette.primary.main : palette.secondary.light;
    },
    height: spacing(3.5),
    fontSize: typography.pxToRem(11),
    backgroundColor: '#fff',
  },
  label: {
    padding: 0,
    paddingLeft: spacing(0.5),
  },
}));
